import axios from 'axios'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    // Borradores cierres contables
    accountingCloseDraft: {
      tableData: [],
      totalAccountingCloseDraft: 0
    },
    queryAccountingCloseDraft: {
      page: 0,
      size: 20,
      sort: 'closeDateTime,DESC',
      statusId: 1, // El estado es 1
      startDateFrom: fn.initDateFrom(3),
      endDateTo: fn.initDateTo()
    },
    listSelectedFiltersAccountingCloseDraft: [],
    // Datos Select Filtros Borradores cierres contables
    optionsFilterBuyerAccountingCloseDraft: [],
    optionsFilterInvoiceNumberAccountingCloseDraft: [],
    optionsFilterNameAccountingCloseDraft: [],
    optionsFilterNameChildCloseDraft: [],
    optionsFilterStartDateAccountingCloseDraft: [],
    optionsFilterEndDateAccountingCloseDraft: [],
    optionsFilterCloseDateAccountingCloseDraft: []
  }
  return session
}
function initLocal () {
  const local = {

    // Columnas Tabla Borradores cierres contables
    isShowServiceAccountingCloseDraft: true,
    isShowBuyerAccountingCloseDraft: true,
    isShowNameAccountingCloseDraft: true,
    isShowCloseDateTimeAccountingCloseDraft: true,
    isShowStartDateAccountingCloseDraft: true,
    isShowEndDateAccountingCloseDraft: true,
    isShowStatusAccountingCloseDraft: true,
    isShowChildNameAccountingCloseDraft: true
  }
  return local
}
function setByUserLocalCierres () {
  const local = {
    // ColumnasTablaBorradorescierrescontables
    isShowServiceAccountingCloseDraft: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cierrescontablesBorradores.isShowServiceAccountingCloseDraft,
    isShowBuyerAccountingCloseDraft: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cierrescontablesBorradores.isShowBuyerAccountingCloseDraft,
    isShowNameAccountingCloseDraft: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cierrescontablesBorradores.isShowNameAccountingCloseDraft,
    isShowCloseDateTimeAccountingCloseDraft: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cierrescontablesBorradores.isShowCloseDateTimeAccountingCloseDraft,
    isShowStartDateAccountingCloseDraft: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cierrescontablesBorradores.isShowStartDateAccountingCloseDraft,
    isShowEndDateAccountingCloseDraft: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cierrescontablesBorradores.isShowEndDateAccountingCloseDraft,
    isShowStatusAccountingCloseDraft: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cierrescontablesBorradores.isShowStatusAccountingCloseDraft,
    isShowChildNameAccountingCloseDraft: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cierrescontablesBorradores.isShowChildNameAccountingCloseDraft
  }
  return local
}
// state
const state = {
  userConfigLocalStorage: '',
  local: {

    // Columnas Tabla Borradores cierres contables
    isShowServiceAccountingCloseDraft: true,
    isShowBuyerAccountingCloseDraft: true,
    isShowNameAccountingCloseDraft: true,
    isShowCloseDateTimeAccountingCloseDraft: true,
    isShowStartDateAccountingCloseDraft: true,
    isShowEndDateAccountingCloseDraft: true,
    isShowStatusAccountingCloseDraft: true,
    isShowChildNameAccountingCloseDraft: true
  },

  session: initSession()
}

// getters
const getters = {
  // Datos Tabla Borradores cierres contables
  accountingCloseDraft: state => {
    return state.session.accountingCloseDraft
  },
  queryAccountingCloseDraft: state => {
    return state.session.queryAccountingCloseDraft
  },
  listSelectedFiltersAccountingCloseDraft: state => {
    return state.session.listSelectedFiltersAccountingCloseDraft
  },

  // Datos Select Filtros Borradores cierres contables
  optionsFilterBuyerAccountingCloseDraft: state => {
    return state.session.optionsFilterBuyerAccountingCloseDraft
  },
  optionsFilterInvoiceNumberAccountingCloseDraft: state => {
    return state.session.optionsFilterInvoiceNumberAccountingCloseDraft
  },

  optionsFilterNameAccountingCloseDraft: state => {
    return state.session.optionsFilterNameAccountingCloseDraft
  },
  optionsFilterNameChildCloseDraft: state => {
    return state.session.optionsFilterNameChildCloseDraft
  },
  optionsFilterStartDateAccountingCloseDraft: state => {
    return state.session.optionsFilterStartDateAccountingCloseDraft
  },
  optionsFilterEndDateAccountingCloseDraft: state => {
    return state.session.optionsFilterEndDateAccountingCloseDraft
  },
  optionsFilterCloseDateAccountingCloseDraft: state => {
    return state.session.optionsFilterCloseDateAccountingCloseDraft
  },

  // Columnas Tabla Borradores cierres contables
  isShowServiceAccountingCloseDraft: state => {
    return state.local.isShowServiceAccountingCloseDraft
  },
  isShowBuyerAccountingCloseDraft: state => {
    return state.local.isShowBuyerAccountingCloseDraft
  },
  isShowNameAccountingCloseDraft: state => {
    return state.local.isShowNameAccountingCloseDraft
  },
  isShowCloseDateTimeAccountingCloseDraft: state => {
    return state.local.isShowCloseDateTimeAccountingCloseDraft
  },
  isShowStartDateAccountingCloseDraft: state => {
    return state.local.isShowStartDateAccountingCloseDraft
  },
  isShowEndDateAccountingCloseDraft: state => {
    return state.local.isShowEndDateAccountingCloseDraft
  },
  isShowStatusAccountingCloseDraft: state => {
    return state.local.isShowStatusAccountingCloseDraft
  },
  isShowChildNameAccountingCloseDraft: state => {
    return state.local.isShowChildNameAccountingCloseDraft
  }
}

// actions
const actions = {
  // Crear key Usuario
  setUserNameCierres ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalCierres()
    }
  },
  isNewVersionCierresContablesBorradoresLocalState ({ state }, localStorage) {
    return fn.isNewVersion(state, localStorage.cierrescontablesBorradores)
  },

  // Servicio para traer detalle de un borrador de  cierrecontable
  async getAccountingClose ({ commit, rootState }, draftId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/draftaccountingclose/' + draftId
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async addChildAccounting ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/draftaccountingclose/addChildAccounting',
        data: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async saveAccounting ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/draftaccountingclose/create',
        data: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async getAccountingClosesDraft ({ commit, rootState }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/draftaccountingclose',
        params: data.query
      })

      commit('ACCOUNTING_CLOSE_DRAFT_STATE', {
        tableData: response.data.content,
        totalAccountingCloseDraft: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR: ', error.response)
      throw error.response
    }
  },

  // Facturas asociadas a un borrador
  async getAccountinCloseInvoiceNotes ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/draftaccountingclose/' + data.draftId + '/invoicenote',
        params: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Facturas para asociar a un borrador
  async getAllAccountinCloseInvoiceNotes ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/draftaccountingclose/' + data.draftId + '/invoicenotes',
        params: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Método para crear o actualizar un cierre
  async createAccounting ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/draftaccountingclose/create',
        data: data.query
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Elimina un borrador de cierre contable
  async deleteAccountingClosesDraft ({ commit, rootState }, draftId) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: '/draftaccountingclose/' + draftId
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Datos Tabla Borradores cierres contables
  accountingCloseDraftState: ({ commit }, payload) => {
    commit('ACCOUNTING_CLOSE_DRAFT_STATE', payload)
  },
  queryAccountingCloseDraftState: ({ commit }, payload) => {
    commit('QUERY_ACCOUNTING_CLOSE_DRAFT_STATE', payload)
  },
  listSelectedFiltersAccountingCloseDraftState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_ACCOUNTING_CLOSE_DRAFT_STATE', payload)
  },

  // Datos Select Filtros Borradores cierres contables
  optionsFilterBuyerAccountingCloseDraftState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_BUYER_ACCOUNTING_CLOSE_DRAFT', payload)
  },
  optionsFilterInvoiceNumberAccountingCloseDraftState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_INVOICENUMBER_ACCOUNTING_CLOSE_DRAFT', payload)
  },

  optionsFilterNameAccountingCloseDraftState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_NAME_ACCOUNTING_CLOSE_DRAFT', payload)
  },
  optionsFilterNameChildCloseDraftState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_CHILDNAME_ACCOUNTING_CLOSE_DRAFT', payload)
  },
  optionsFilterStartDateAccountingCloseDraftState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_STARTDATE_ACCOUNTING_CLOSE_DRAFT', payload)
  },
  optionsFilterEndDateAccountingCloseDraftState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_ENDDATE_ACCOUNTING_CLOSE_DRAFT', payload)
  },
  optionsFilterCloseDateAccountingCloseDraftState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_CLOSEDATE_ACCOUNTING_CLOSE_DRAFT', payload)
  },

  // Columnas Tabla Borradores cierres contables
  isShowServiceAccountingCloseDraft: ({ commit }, payload) => {
    commit('IS_SHOW_SERVICE_ACCOUNTING_CLOSE_DRAFT', payload)
  },
  isShowBuyerAccountingCloseDraft: ({ commit }, payload) => {
    commit('IS_SHOW_BUYER_ACCOUNTING_CLOSE_DRAFT', payload)
  },
  isShowNameAccountingCloseDraft: ({ commit }, payload) => {
    commit('IS_SHOW_NAME_ACCOUNTING_CLOSE_DRAFT', payload)
  },
  isShowCloseDateTimeAccountingCloseDraft: ({ commit }, payload) => {
    commit('IS_SHOW_CLOSEDATE_ACCOUNTING_CLOSE_DRAFT', payload)
  },
  isShowStartDateAccountingCloseDraft: ({ commit }, payload) => {
    commit('IS_SHOW_STARTDATE_ACCOUNTING_CLOSE_DRAFT', payload)
  },
  isShowEndDateAccountingCloseDraft: ({ commit }, payload) => {
    commit('IS_SHOW_ENDDATE_ACCOUNTING_CLOSE_DRAFT', payload)
  },
  isShowStatusAccountingCloseDraft: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_ACCOUNTING_CLOSE_DRAFT', payload)
  },
  isShowChildNameAccountingCloseDraft: ({ commit }, payload) => {
    commit('IS_SHOW_CHILDNAME_ACCOUNTING_CLOSE_DRAFT', payload)
  }
}

// mutations
const mutations = {
  resetSessionCierresContablesBorradores (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  draftAccountingCloseDatesSuperAdmin (state) {
    state.session.queryAccountingCloseDraft.startDateFrom = fn.initDateFrom(1)
  },
  // Borradores cierres contables
  'ACCOUNTING_CLOSE_DRAFT_STATE' (state, payload) {
    state.session.accountingCloseDraft = payload
  },
  'QUERY_ACCOUNTING_CLOSE_DRAFT_STATE' (state, payload) {
    state.session.queryAccountingCloseDraft = payload
  },
  'LIST_SELECTED_FILTERS_ACCOUNTING_CLOSE_DRAFT_STATE' (state, payload) {
    state.session.listSelectedFiltersAccountingCloseDraft = payload
  },

  // Datos Select Filtros Borradores cierres contables
  'OPTIONS_FILTER_BUYER_ACCOUNTING_CLOSE_DRAFT' (state, payload) {
    state.session.optionsFilterBuyerAccountingCloseDraft = payload
  },
  'OPTIONS_FILTER_INVOICENUMBER_ACCOUNTING_CLOSE_DRAFT' (state, payload) {
    state.session.optionsFilterInvoiceNumberAccountingCloseDraft = payload
  },

  'OPTIONS_FILTER_NAME_ACCOUNTING_CLOSE_DRAFT' (state, payload) {
    state.session.optionsFilterNameAccountingCloseDraft = payload
  },
  'OPTIONS_FILTER_CHILDNAME_ACCOUNTING_CLOSE_DRAFT' (state, payload) {
    state.session.optionsFilterNameChildCloseDraft = payload
  },
  'OPTIONS_FILTER_STARTDATE_ACCOUNTING_CLOSE_DRAFT' (state, payload) {
    state.session.optionsFilterStartDateAccountingCloseDraft = payload
  },

  'OPTIONS_FILTER_ENDDATE_ACCOUNTING_CLOSE_DRAFT' (state, payload) {
    state.session.optionsFilterEndDateAccountingCloseDraft = payload
  },
  'OPTIONS_FILTER_CLOSEDATE_ACCOUNTING_CLOSE_DRAFT' (state, payload) {
    state.session.optionsFilterCloseDateAccountingCloseDraft = payload
  },

  // Columnas Tabla Borradores cierres contables
  'IS_SHOW_SERVICE_ACCOUNTING_CLOSE_DRAFT' (state, payload) {
    state.local.isShowServiceAccountingCloseDraft = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cierrescontablesBorradores.isShowServiceAccountingCloseDraft = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_BUYER_ACCOUNTING_CLOSE_DRAFT' (state, payload) {
    state.local.isShowBuyerAccountingCloseDraft = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cierrescontablesBorradores.isShowBuyerAccountingCloseDraft = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NAME_ACCOUNTING_CLOSE_DRAFT' (state, payload) {
    state.local.isShowNameAccountingCloseDraft = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cierrescontablesBorradores.isShowNameAccountingCloseDraft = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CLOSEDATE_ACCOUNTING_CLOSE_DRAFT' (state, payload) {
    state.local.isShowCloseDateTimeAccountingCloseDraft = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cierrescontablesBorradores.isShowCloseDateTimeAccountingCloseDraft = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STARTDATE_ACCOUNTING_CLOSE_DRAFT' (state, payload) {
    state.local.isShowStartDateAccountingCloseDraft = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cierrescontablesBorradores.isShowStartDateAccountingCloseDraft = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ENDDATE_ACCOUNTING_CLOSE_DRAFT' (state, payload) {
    state.local.isShowEndDateAccountingCloseDraft = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cierrescontablesBorradores.isShowEndDateAccountingCloseDraft = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_ACCOUNTING_CLOSE_DRAFT' (state, payload) {
    state.local.isShowStatusAccountingCloseDraft = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cierrescontablesBorradores.isShowStatusAccountingCloseDraft = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CHILDNAME_ACCOUNTING_CLOSE_DRAFT' (state, payload) {
    state.local.isShowChildNameAccountingCloseDraft = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cierrescontablesBorradores.isShowChildNameAccountingCloseDraft = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
